import { useStore } from "vuex";
import { ApiResponse } from "@/stores/api/types.ts";
import { CategoriesDocument } from "@/types/categories.ts";

export default function useCategoriesActions() {
  const store = useStore();
  async function fetch(): Promise<ApiResponse<CategoriesDocument> | undefined> {
    return store.dispatch("api/fetchCategories");
  }

  return {
    fetch,
  };
}
